import formComponent from '@/util/proto/formComponent'
import global from '@/util/mixin/global'

export default {
  mixins:[global],
  props:{
    id:{
      default:null
    },
  },
  data(){
    return {
      loading:false,
      state:{ remark:null }
    }
  },
  methods:{
    save(){
      let standardCarIds = Array.isArray(this.id) ? this.id : (this.id !== undefined && this.id !== null) ? [this.id] : []

      const params = { standardCarIds , ...this.state }

      this.loading = true

      this.$request.stdApplicationCreate(params).then(resp => {
        this.loading = false
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('申请成功')
          this.$emit('ok')
        }
      })  
    },
  },
  render(){
    const { data , id , loading } = this
    const subject = this.subject
    let msg = Array.isArray(id) ? `共选中 ${id.length} 辆车辆，请确认为这些车辆提交车辆标准化申请！` : null
    let tip = msg ? <Alert type="success">{msg}</Alert> : null
    return (
      <div>
        <div class="modal-body">
          {tip}
          <sl-detail-list col={1} label-width="75px" label-align="right" style="padding:12px;">
            <sl-detail-list-item title="联系人">
              {subject.legalName}
            </sl-detail-list-item>
            <sl-detail-list-item title="联系电话">
              {subject.companyPhone}
            </sl-detail-list-item>
            <sl-detail-list-item title="备注">
              <Input type="textarea" placeholder="" autosize={{ minRows: 2, maxRows: 6 }} v-model={this.state.remark} />
            </sl-detail-list-item>
          </sl-detail-list>

        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.save} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}